import {
  B2BSpinner,
  LoadingIndicator,
  TravelerSelectStep,
  hasInvalidBirthdate,
} from "halifax";
import React, { useMemo } from "react";
import { CallState, ICorpPerson, ITravelerStepErrors } from "redmond";

import { DriverSelectDropdownForm } from "../DriverSelectDropdownForm";
import { CarBookPassengerSelectionConnectorProps } from "./container";
import "./styles.scss";
import * as constants from "./textConstants";

export interface ICarBookPassengerSelectionProps
  extends CarBookPassengerSelectionConnectorProps {
  setProgress: (progress: TravelerSelectStep) => void;
  showErrors: ITravelerStepErrors;
  setShowErrors: (showErrors: ITravelerStepErrors) => void;
  disableEditTravelerInfo: boolean;
}

export const CarBookPassengerSelection = (
  props: ICarBookPassengerSelectionProps
) => {
  const {
    userPassengerCallState,
    travelers,
    setProgress,
    selectedTravelerId,
    setUserSelectedPassengerIds,
    isMissingLicense,
    showErrors,
    setShowErrors,
    fetchCorpUserPassengers,
    disableEditTravelerInfo,
  } = props;

  React.useEffect(() => {
    fetchCorpUserPassengers();
  }, []);

  React.useEffect(() => {
    if (
      travelers.length === 1 &&
      !((travelers[0] as ICorpPerson).isMissingInfo ?? false) &&
      !hasInvalidBirthdate(travelers[0].dateOfBirth)
    ) {
      setUserSelectedPassengerIds({
        userSelectedPassengerIds: [travelers[0].id],
      });
    }
  }, [travelers]);

  React.useEffect(() => {
    if (selectedTravelerId && isMissingLicense) {
      setProgress(TravelerSelectStep.TravelerInfoForm);
    }
  }, [selectedTravelerId, isMissingLicense]);

  const selectedTravelers = useMemo(
    () => travelers.filter((t) => t.id === selectedTravelerId),
    [travelers, selectedTravelerId]
  );

  return userPassengerCallState === CallState.InProcess ? (
    <LoadingIndicator
      indicatorSize="small"
      indicator={B2BSpinner}
      message={
        userPassengerCallState === CallState.InProcess
          ? constants.UPDATE_TEXT
          : constants.VALIDATE_TEXT
      }
    />
  ) : (
    <DriverSelectDropdownForm
      setProgress={setProgress}
      showErrors={showErrors}
      setShowErrors={setShowErrors}
      disableEditTravelerInfo={disableEditTravelerInfo}
      selectedTravelers={selectedTravelers}
      isMissingLicense={isMissingLicense}
      updateSelectedTravelersList={(traveler) => {
        setUserSelectedPassengerIds({
          userSelectedPassengerIds: [traveler.id],
        });
      }}
      removeSelectedTraveler={() =>
        setUserSelectedPassengerIds({
          userSelectedPassengerIds: [],
        })
      }
    />
  );
};
